export default {
    login: {
        title: "帳號登入",
        loadingText: "登入中",
        form: {
            email: {
                message: "請填寫信箱地址",
                placeholder: "信箱地址"
            },
            password: {
                message: "請填寫密碼",
                placeholder: "密碼"
            },
            button: {
                forgotPassword: "忘記密碼",
                login: "立即登入",
                otherLogin: "或快速登入"
            }
        },
        methods: {
            loginMessage: "登入成功"
        }
    },
    findPassword: {
        form: {
            email: {
                message: "請填寫信箱地址",
                placeholder: "信箱地址"
            },
            verificationCode: {
                message: "請填寫驗證碼",
                placeholder: "輸入驗證碼",
                loadingText: "獲取中"
            },
            button: {
                verificationCode: "驗證碼",
                findPassword: "找回密碼",
                goLogin: "返回登入頁"
            }
        }
    },
}